import React, { createContext, useContext, useState, useEffect } from 'react';
import { xtreamApi } from '../services/xtreamApi';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [serverInfo, setServerInfo] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('xtream_user');
    const storedServer = localStorage.getItem('xtream_server');
    const storedCredentials = localStorage.getItem('xtream_credentials');
    
    if (storedUser && storedServer && storedCredentials) {
      const credentials = JSON.parse(storedCredentials);
      xtreamApi.setCredentials(credentials.serverUrl, credentials.username, credentials.password, credentials.serverId || 0);
      setUser(JSON.parse(storedUser));
      setServerInfo(JSON.parse(storedServer));
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const login = async (username, password, serverId = 0) => {
    const data = await xtreamApi.login(username, password, serverId);
    
    const userData = {
      username: data.user_info.username,
      status: data.user_info.status,
      expDate: data.user_info.exp_date ? 
        new Date(parseInt(data.user_info.exp_date) * 1000).toLocaleDateString() : 'N/A',
      maxConnections: data.user_info.max_connections,
      activeCons: data.user_info.active_cons,
      isTrial: data.user_info.is_trial
    };
    
    const serverData = {
      url: data.server_info.url,
      port: data.server_info.port,
      httpsPort: data.server_info.https_port,
      serverProtocol: data.server_info.server_protocol,
      timezone: data.server_info.timezone
    };
    
    // Store server_url internally for stream URL construction
    const credentials = { serverUrl: data.server_url, username, password, serverId };
    
    setUser(userData);
    setServerInfo(serverData);
    setIsAuthenticated(true);
    
    localStorage.setItem('xtream_user', JSON.stringify(userData));
    localStorage.setItem('xtream_server', JSON.stringify(serverData));
    localStorage.setItem('xtream_credentials', JSON.stringify(credentials));
    
    return data;
  };

  const logout = () => {
    xtreamApi.clearCredentials();
    setUser(null);
    setServerInfo(null);
    setIsAuthenticated(false);
    localStorage.removeItem('xtream_user');
    localStorage.removeItem('xtream_server');
    localStorage.removeItem('xtream_credentials');
  };

  return (
    <AuthContext.Provider value={{
      user,
      serverInfo,
      isAuthenticated,
      isLoading,
      login,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
